import { Box, Stack, Typography } from '@mui/material';
import { WarningAmber } from '@mui/icons-material';
import { Alert } from 'reactstrap';
import { AISuggestionsTitle } from './AISuggestionsTitle';

export interface AISuggestionsWarningStateProps {
  children?: React.ReactNode;
}

export const AISuggestionsWarningState = ({
  children,
}: AISuggestionsWarningStateProps) => (
  <Stack gap={0.625}>
    <AISuggestionsTitle />
    <Alert
      color="warning"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '8px',
      }}
    >
      <WarningAmber style={{ color: '#856404', fontSize: '16px' }} />
      <Box>
        <Typography
          variant="body2"
          fontWeight={600}
          style={{ color: '#856404' }}
        >
          No AI Suggestion Available
        </Typography>
        <Typography variant="body2" style={{ color: '#856404' }}>
          The AI did not find enough data to confidently suggest a match. Please
          rename manually.
        </Typography>
      </Box>
    </Alert>
    {children}
  </Stack>
);
